
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StylePositionType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { ModalSlotName, ModalViewType } from '@/ui-kit/components/modal/enums';
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import Button from '@/ui-kit/components/button';
import Gutter from '@/ui-kit/components/gutter';
import FilterRangeYearBuilt from '@/components/filters/range-year-built';
import FilterRangeLandSize from '@/components/filters/range-land-size';
import FiltersListingStatus from '@/components/filters/listing-status';
import FiltersListingType from '@/components/filters/listing-type';
import FilterRangeFinishedArea from '@/components/filters/range-finished-area';
import FilterPropertyTypes from '@/components/filters/property-types';
import FilterBeds from '@/components/filters/beds';
import FilterBaths from '@/components/filters/baths';
import FilterPrice from '@/components/filters/price';
import { FilterType } from '@/components/filters/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import WindowSize from '@/ui-kit/mixins/windowSize';
import SearchFiltersEvents from '../../mixins/SearchFiltersEvents';

export default {
  name: 'SearchFiltersMobileModal',
  components: {
    Typography,
    FilterRangeYearBuilt,
    FilterRangeLandSize,
    FiltersListingStatus,
    FiltersListingType,
    FilterRangeFinishedArea,
    FilterPropertyTypes,
    FilterBeds,
    FilterBaths,
    FilterPrice,
    Button,
    Gutter,
    ModalWindow,
  },
  mixins: [ModalCommonProps, WindowSize, SearchFiltersEvents],
  data() {
    return {
      filters: { ...this.modalData.filters },
      StyleColorSchemeType,
      StyleSizeType,
      StylePositionType,
      ButtonFillType,
      ModalSlotName,
      FilterType,
      StyleFontWeightType,
      TypographyType,
    };
  },
  computed: {
    responsiveModalOptions() {
      const viewType = this.isSmallerThan(StyleSizeType.Small)
        ? ModalViewType.FullWidth
        : ModalViewType.FitContent;

      return {
        ...this.modalOptions,
        viewType,
      };
    },
  },
  methods: {
    changeFilter(filterType, value) {
      this.trackFilterChange(filterType, value);
      this.filters[filterType] = value;
    },
    handlePropertyTypeFilterChange(value) {
      this.changeFilter(FilterType.BuildingClass, value);
    },
    handlePriceFilterChange(value) {
      this.changeFilter(FilterType.Price, value);
    },
    handleBedsFilterChange(value) {
      this.changeFilter(FilterType.Beds, value);
    },
    handleBathsFilterChange(value) {
      this.changeFilter(FilterType.Baths, value);
    },
    handleListingTypeFilterChange(value) {
      this.changeFilter(FilterType.ListingType, value);
    },
    handleListingStatusFilterChange(value) {
      this.changeFilter(FilterType.ListingStatus, value);
    },
    handleFinishedAreaFilterChange(value) {
      this.changeFilter(FilterType.FinishedArea, value);
    },
    handleLandSizeFilterChange(value) {
      this.changeFilter(FilterType.LandSize, value);
    },
    handleYearBuiltFilterChange(value) {
      this.changeFilter(FilterType.YearBuilt, value);
    },
    handleApplyClick() {
      return this.closeHandler(this.filters);
    },
    handleButtonIconClose() {
      return this.closeHandler();
    },
    handleResetClick() {
      this.modalData.resetFilters();

      return this.closeHandler();
    },
  },
};
